import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CHECKIN_PASSENGER_INPUT_RESULT_STORE_NAME,
  CheckinPassengerInputResultState,
} from './checkin-passenger-input-result.state';

/** Select CheckinPassengerInputResult State */
export const selectCheckinPassengerInputResultState = createFeatureSelector<CheckinPassengerInputResultState>(
  CHECKIN_PASSENGER_INPUT_RESULT_STORE_NAME
);

/** Select CheckinPassengerInputResult isPending status */
export const selectCheckinPassengerInputResultIsPendingStatus = createSelector(
  selectCheckinPassengerInputResultState,
  (state) => !!state.isPending
);

/** Select CheckinPassengerInputResult isFailure status */
export const selectCheckinPassengerInputResultIsFailureStatus = createSelector(
  selectCheckinPassengerInputResultState,
  (state) => !!state.isFailure
);
